import type { LucideIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description?: string
  ctaLabel?: string
  onCtaClick?: () => void
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  ctaLabel,
  onCtaClick,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-12 text-center">
      <div className="bg-surface-container mb-4 flex size-16 items-center justify-center rounded-full">
        <Icon className="text-on-surface-variant size-8" />
      </div>
      <p className="text-on-surface-variant text-lg font-medium">{title}</p>
      {description && (
        <p className="text-on-surface-variant/70 mt-1 max-w-[240px] text-sm">{description}</p>
      )}
      {ctaLabel && onCtaClick && (
        <Button variant="default" size="sm" className="mt-4" onClick={onCtaClick}>
          {ctaLabel}
        </Button>
      )}
    </div>
  )
}
